import { z } from 'zod';

export const phone = z
  .string()
  .min(1, { message: 'Введите номер телефона' })
  .min(11, { message: 'Недостаточно символов' });